import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { loginBusiness } from '../actions/index'

class LoginBusiness extends React.Component {
    constructor() {
        super()
        this.state = {
            username: '',
            password: '',
        }
    }

    handleChange = (evt) => {
        evt.preventDefault()
        this.setState({
            [evt.target.name]: evt.target.value,
        })
    }

    handleSubmit = (evt) => {
        evt.preventDefault()
        const { username, password } = this.state

        this.props.loginBusiness(username, password)
            .then(() => {
                this.props.history.push("/businessdashboard")
            })
            .catch((err) => { console.error(err) })
    }

    render() {
        const { username, password } = this.state
        const { isLoading, } = this.props
        return (
            <div>
                <h1>Business Log In</h1>
                <form onSubmit={this.handleSubmit}>
                    {/* {errorMessage && <p className="error">{errorMessage}</p>} */}
                    <input type="text" name="username" placeholder="Username" value={username} onChange={this.handleChange} /><br/>
                    <input type="password" name="password" placeholder="Password" value={password} onChange={this.handleChange} /><br/>
                    {isLoading
                        ? <p>Logging in...</p>
                        : <button type="submit">Log In</button>}
                </form>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    isLoading: state.isLoading,
    errorMessage: state.errorMessage
})

const mapDispatchToProps = {
    loginBusiness,
}

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(LoginBusiness)
)